module.exports = __webpack_public_path__ + "img/twitter.e801d0e7.png";